// Placeholder deck, replaced by the full deck for this course.
import { applyOkiruTemplate } from '../okiruPresentationTemplate';

export const manifest = applyOkiruTemplate(
  {
    id: 'credit-analysis-lending-deal-structuring',
    title: 'Credit Analysis & Lending Deal Structuring',
    subtitle: 'Okiru Learn · Three-day classroom programme',
    modules: [{ index: 1, name: 'Welcome' }],
  },
  'okiru-light',
);

export const slides = [
  { id: 1, layout: 'title', kicker: 'Okiru · Three-day classroom programme', title: 'Credit Analysis & Lending Deal Structuring', lead: 'Placeholder', meta: ['Okiru Learn'] },
];
